export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Settings-Gray-63c22a605d3574141f499a9e374eb45e.svg";